module.exports = {
          srcSet: __webpack_public_path__ + "cf8822fb3757b0645bdbcff0fc71c6f0-5000.png"+" 5000w",
          images:[ {path: __webpack_public_path__ + "cf8822fb3757b0645bdbcff0fc71c6f0-5000.png",width: 5000,height: 1163}],
          src: __webpack_public_path__ + "cf8822fb3757b0645bdbcff0fc71c6f0-5000.png",
          toString:function(){return __webpack_public_path__ + "cf8822fb3757b0645bdbcff0fc71c6f0-5000.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACn//wCP//8Wdf//B/8AAADxuZ8A77ipOufPcbrywF80/4SkLP+MmQAA84qNAPOFmSPxtF8c/7hlAJFRmADkwZ5Pp66cyafDvhS9w/8Qv8f/AD15LUTJ4+MJAAAAAElFTkSuQmCC",
          width: 5000,
          height: 1163
        }